export default __webpack_public_path__ + "static/media/scikit-learn.2144585f.svg";